import Vue from 'vue';
import CompareFields from './CompareFields.vue';

new Vue({
    el: 'compare-fields',
    components: {
        CompareFields,
    },
});
